const getNumberOfAiGeneratedBlocks = (rootState) => rootState.ui.numberOfAiGeneratedBlocks;

export default getNumberOfAiGeneratedBlocks;
